import { Editor } from '@tiptap/react'
import { Button, Input, Modal, Tooltip } from 'antd'
import { Code1 } from 'iconsax-react'
import { useState } from 'react'

import { useTranslation } from 'react-i18next'

import { useStyles } from './styles'

type Props = {
  editor: Editor
}

export const SourceCodeButton = ({ editor }: Props) => {
  const { t } = useTranslation()

  const [isOpen, setIsOpen] = useState(false)
  const [htmlContent, setHtmlContent] = useState('')
  const { styles } = useStyles()

  const onOpen = () => {
    const currentHtml = editor.getHTML()
    setHtmlContent(currentHtml)
    setIsOpen(true)
  }

  const onSave = () => {
    editor.commands.setContent(htmlContent)
    setIsOpen(false)
  }

  const onCancel = () => {
    setIsOpen(false)
    setHtmlContent('')
  }

  return (
    <>
      <Tooltip title={t('editor.source_code')}>
        <Button icon={<Code1 size={14} />} onClick={onOpen} />
      </Tooltip>

      <Modal
        open={isOpen}
        title={t('editor.html_source_code')}
        onOk={onSave}
        onCancel={onCancel}
        okText={t('editor.save')}
        cancelText={t('editor.cancel')}
        width={600}
        maskClosable={false}
      >
        <Input.TextArea
          value={htmlContent}
          onChange={(e) => setHtmlContent(e.target.value)}
          rows={15}
          className={styles.sourceCodeTextarea}
          placeholder={t('editor.enter_html_source_code')}
        />
      </Modal>
    </>
  )
}
